import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const DEFAULT_PROVIDER_COUNT = 5;

interface ProviderSelectionState {
  selections: Record<string, string[]>;
  select: (scope: string, ids: string[]) => void;
  reset: (scope: string) => void;
}

export function selectionScope(branchId: string, departmentId: string): string {
  return `${branchId}|${departmentId}`;
}

export const useProviderSelection = create<ProviderSelectionState>()(
  persist(
    (set) => ({
      selections: {},
      select: (scope, ids) => set((state) => ({ selections: { ...state.selections, [scope]: ids } })),
      reset: (scope) =>
        set((state) => {
          const { [scope]: _dropped, ...rest } = state.selections;
          return { selections: rest };
        }),
    }),
    { name: 'his.calendar.providers', storage: createJSONStorage(() => localStorage) },
  ),
);

export function visibleProviders<T extends { id: string }>(providers: readonly T[], chosen: string[] | undefined): T[] {
  if (!chosen) return providers.slice(0, DEFAULT_PROVIDER_COUNT);
  const wanted = new Set(chosen);
  const kept = providers.filter((provider) => wanted.has(provider.id));
  return kept.length > 0 ? kept : providers.slice(0, DEFAULT_PROVIDER_COUNT);
}
